import type React from 'react';

interface LobbyProps {
  coins: number;
  level: number;
  equippedCount: number;
  onPlay: () => void;
  onOpenCards: () => void;
  onOpenShop: () => void;
}

const cardStyle: React.CSSProperties = {
  background: '#16213e',
  border: '1px solid #2f3f6b',
  borderRadius: 14,
  padding: 16,
};

const buttonStyle: React.CSSProperties = {
  width: '100%',
  border: '1px solid #2f3f6b',
  background: '#1d3a64',
  color: '#fff',
  borderRadius: 12,
  padding: '14px 16px',
  fontSize: 18,
  fontWeight: 700,
  cursor: 'pointer',
};

export function Lobby({ coins, level, equippedCount, onPlay, onOpenCards, onOpenShop }: LobbyProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        maxWidth: 480,
        margin: '0 auto',
        padding: 16,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <h1 style={{ margin: 0, fontSize: 28 }}>⚡ Henry Unstoppable</h1>

      <div style={{ ...cardStyle, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <div>⭐ Level: {level}</div>
        <div>🪙 Coins: {coins}</div>
      </div>

      <div style={{ ...cardStyle, minHeight: 120 }}>
        <div style={{ fontSize: 14, color: '#9fb3d8' }}>Hero Display</div>
        <div style={{ fontSize: 52, textAlign: 'center', marginTop: 8 }}>🧙‍♂️</div>
        <div style={{ textAlign: 'center', color: '#9fb3d8' }}>Equipped cards: {equippedCount}/3</div>
      </div>

      <div style={{ display: 'grid', gap: 12 }}>
        <button type="button" style={{ ...buttonStyle, background: '#235f3f' }} onClick={onPlay}>
          ▶ Play
        </button>
        <button type="button" style={buttonStyle} onClick={onOpenCards}>
          🃏 Cards
        </button>
        <button type="button" style={buttonStyle} onClick={onOpenShop}>
          🛒 Shop
        </button>
      </div>
    </div>
  );
}
